import { render, staticRenderFns } from "./floating.vue?vue&type=template&id=738e6441&scoped=true"
import script from "./floating.vue?vue&type=script&lang=js"
export * from "./floating.vue?vue&type=script&lang=js"
import style0 from "./floating.vue?vue&type=style&index=0&id=738e6441&prod&lang=less"
import style1 from "./floating.vue?vue&type=style&index=1&id=738e6441&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738e6441",
  null
  
)

export default component.exports